import React from "react";
import Grid from "@mui/material/Grid2";
import PieChartDisplay from "./PieChartDisplay";
import LineChartDisplay from "./LineChartDisplay";
import TableDisplay from "./TableDisplay";

const Display = ({ result, config }) => {
  if (result) {
    return (result.table || result.pie_chart || result.line_chart) ? (
      <Grid container spacing={2}>
        {result.pie_chart && (
          <Grid size={12} sx={{ display: "flex", alignItems: "center", pt: 4 }}>
            <PieChartDisplay data={result.pie_chart} currencyPrefix={config.currency_prefix} />
          </Grid>
        )}
        {result.line_chart && (
          <Grid size={12} sx={{ display: "flex", alignItems: "center" }}>
            <LineChartDisplay data={result.line_chart} currencyPrefix={config.currency_prefix} />
          </Grid>
        )}
        {result.table && (
          <Grid size={12} sx={{ display: "flex", alignItems: "center", pt: 4 }}>
            <TableDisplay data={result.table} />
          </Grid>
        )}
      </Grid>
    ) : (
      <pre>{JSON.stringify(result, null, 2)}</pre>
    );
  }
  return null;
};

export default Display;
